import { HgSupportedLanguage } from '@smg-real-estate/domus';

/**
 * IS24-specific property type URL segments (using plural forms)
 * This mapping defines how property types should appear in IS24 URLs
 * which typically use plural forms vs. Homegate's singular forms
 */
export const IS24_PROPERTY_SEGMENTS = {
  REAL_ESTATE: {
    [HgSupportedLanguage.DE]: 'immobilien',
    [HgSupportedLanguage.FR]: 'immobilier',
    [HgSupportedLanguage.IT]: 'immobili',
    [HgSupportedLanguage.EN]: 'real-estate',
  },
  HOUSE: {
    [HgSupportedLanguage.DE]: 'haeuser',
    [HgSupportedLanguage.FR]: 'maisons',
    [HgSupportedLanguage.IT]: 'case',
    [HgSupportedLanguage.EN]: 'houses',
  },
  FLAT: {
    [HgSupportedLanguage.DE]: 'wohnung',
    [HgSupportedLanguage.FR]: 'appartement',
    [HgSupportedLanguage.IT]: 'appartamento',
    [HgSupportedLanguage.EN]: 'flat',
  },
  COMMERCIAL: {
    [HgSupportedLanguage.DE]: 'gewerbe',
    [HgSupportedLanguage.FR]: 'commercial',
    [HgSupportedLanguage.IT]: 'commerciale',
    [HgSupportedLanguage.EN]: 'commercial',
  },
  PARKING: {
    [HgSupportedLanguage.DE]: 'parkplaetze',
    [HgSupportedLanguage.FR]: 'parkings',
    [HgSupportedLanguage.IT]: 'parcheggi',
    [HgSupportedLanguage.EN]: 'parking-places-garages',
  },
  PLOT: {
    [HgSupportedLanguage.DE]: 'grundstuecke',
    [HgSupportedLanguage.FR]: 'terrains',
    [HgSupportedLanguage.IT]: 'terreni',
    [HgSupportedLanguage.EN]: 'plots',
  },
  INVESTMENT: {
    [HgSupportedLanguage.DE]: 'anlegerobjekte',
    [HgSupportedLanguage.FR]: 'investissements',
    [HgSupportedLanguage.IT]: 'investimenti',
    [HgSupportedLanguage.EN]: 'investment-properties',
  },
  MULTI_FAMILY_HOUSE: {
    [HgSupportedLanguage.DE]: 'mehrfamilienhaeuser',
    [HgSupportedLanguage.FR]: 'immeubles',
    [HgSupportedLanguage.IT]: 'case-plurifamiliari',
    [HgSupportedLanguage.EN]: 'multi-family-houses',
  },
  FURNISHED_FLAT: {
    [HgSupportedLanguage.DE]: 'moeblierte-wohnungen',
    [HgSupportedLanguage.FR]: 'appartements-meubles',
    [HgSupportedLanguage.IT]: 'appartamenti-arredati',
    [HgSupportedLanguage.EN]: 'furnished-apartments',
  },
} as const;
